import { useEffect, useRef, useState } from "react";
import DefenseImg from "../../assets/png/defense2.png";
const DirectSales = () => {
  const [topPartHeight, setTopPartHeight] = useState(0);

  const topPartRef = useRef(null);

  useEffect(() => {
    // Measure the height of the Top Part once it has been rendered
    if (topPartRef.current) {
      setTopPartHeight(topPartRef.current.offsetHeight);
    }
  }, []);

  return (
    <div>
      <div className="custom-container text-center py-[74px] ">
        <div className="md:pb-[102px] sm:pb-[60px] pb-[20px]">
          <div className="font-[Rockwell] 2xl:text-[60px] xl:text-[40px] lg:text-[35px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold text-white">
            TUATARA DIRECT SALES
          </div>
          <div className="2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]  font-[Roboto] font-bold text-white">
            GET TACTICAL SPECIFIC TO YOUR MISSION NEEDS WITH A DEFENSE REPRESENTATIVE TODAY.
          </div>
          <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-white mt-[60px]">
            Government or military purchasing agents or representatives may order Tuatara Government & Defense products
            directly from a Tuatara Defense Sales Representative.
          </div>
        </div>

        <div className="relative flex items-center	justify-center	" style={{ paddingBottom: `${topPartHeight - 200}px` }}>
          <div
            className="bg-[#B4875E] py-[51px] md:px-[86px] px-[10px] absolute top-0"
            style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            ref={topPartRef}
          >
            <div className="2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]  font-bold font-[Roboto] text-white">
              GENERAL GOVERNMENT AND
              <br /> DEFENSE QUOTES
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-7 gap-[0px] mt-[30px]">
              <div className="col-span-4">
                <div className="flex flex-wrap	">
                  <div className="text-start md:mr-[53px] sm:mr-[10px] mr-[0px]">
                    <div className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]  text-[16px] text-white">
                      PHONE
                    </div>
                    <div className="font-[Roboto] font-normal 2xl:text-[21px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]  text-[16px] text-white">
                      (281) 417-2224
                    </div>
                  </div>{" "}
                  <div className="text-start">
                    <div className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]  text-[16px] text-white">
                      MAIL
                    </div>
                    <div className="font-[Roboto] font-normal 2xl:text-[21px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]  text-[16px] text-white">
                      15221 Market St <br />
                      Channelview, TX 77530
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-span-3">
                <div className="md:ml-[53px] sm:ml-[10px] ml-[0px]">
                  <div>
                    <button
                      className="rounded-lg bg-[#F2F2F2] border-[#5B792E] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#5B792E]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px] w-full px-[40px]"
                      style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                    >
                      CONTACT TODAY
                    </button>
                  </div>
                  <div>
                    <button
                      className="rounded-lg bg-[#7ABF5B] border-[#fff] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px] mt-[12px]  w-full px-[40px]"
                      style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                    >
                      GET A QUOTE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <img src={DefenseImg} alt="" className="max-h-[500px] w-full min-h-[350px] object-cover " />
      </div>
    </div>
  );
};
export default DirectSales;
